import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengende() {
  return (
    <section className="challenge_nde p-100 text_nde">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              We started with a comprehensive code analysis to find the flaws in
              the backend operations. We later conducted a thorough business
              analysis of NDE Offshore to understand further and prioritize our
              maintenance tasks.
            </p>
            <p>
              The code analysis revealed the bugs and outdated backend code on
              their web portal. Thus, we had to rewrite a fraction of the
              existing code and add new segments of code to eliminate the
              existing bugs, enhance loading speed, and maximize the efficiency
              of their portal.
            </p>
            <p>
              A planned approach to resolve the existing bugs and maximize the
              efficiency of the code resulted in more stable and flexible web
              portals. The outdated code was replaced with a new, updated code
              with improved backend logic and maximum efficiency.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="challenge_nde_img">
              <StaticImage
                src="../../../images/case-studies/nde/challenges.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={600}
                height={604}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengende;
